import { Link } from 'app/common/link'
import React from 'react'
import { injectIntl } from 'react-intl'
//$FlowFixMe
import appleStore from 'shared/assets/images/apple_store_white.webp'
//$FlowFixMe
import playStore from 'shared/assets/images/play_store_white.webp'
import styled from 'styled-components'
import type { IntlShape } from 'react-intl'
import { colors } from 'app-v2/design-systems'

type Props = {
    border?: boolean,
    intl: IntlShape
}

const ApplicationDownloadComponent = (props: Props) => {
    const { border, intl } = props
    return (
        <AppButtonContainer>
            <AppButtonWrapper border={border} external>
                <Link url={process.env.REACT_APP_IOS_APP} external>
                    <Image src={appleStore} />
                </Link>
            </AppButtonWrapper>
            <AppButtonWrapper border={border}>
                <Link url={process.env.REACT_APP_ANDROID_APP} external>
                    <Image src={playStore} />
                </Link>
            </AppButtonWrapper>
        </AppButtonContainer>
    )
}

const AppButtonContainer = styled.div`
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    width: 320px;
`
const AppButtonWrapper = styled.div`
    width: 100%;
    ${props => props.border && `border: 1px solid ${colors.black}`};
    border-radius: 4px;
`

const Image = styled.img`
    width: 150px;
    height: 50px;
`

const ApplicationDownload = injectIntl(ApplicationDownloadComponent)

export { ApplicationDownload }
